export const checkStatusSessionHistory = (status, providentFundRateHistoryIsActiveBtn, requestType, colorText = false) => {
    if(requestType == 'RATE' && status == 'DRAFT' && providentFundRateHistoryIsActiveBtn === false) {
        if(colorText){
            return 'bg-red-status'
        }else{
            return "หมดอายุ"
        }
    }else if(status == "DRAFT"){
        if(colorText){
            return 'bg-gray-status'
        }else{
            return "แบบร่าง"
        }
    }else if(status == "PENDING"){
        if(colorText){
            return 'bg-orange-status'
        }else{
            return "รอดำเนินการ"
        }
    }else if(status == "SUCCESS"){
        if(colorText){
            return 'bg-green-status'
        }else{
            return "ดำเนินการสำเร็จ"
        }
        
    }else if(status == "CANCEL"){
        if(colorText){
            return 'bg-red-status'
        }else{
            return "ยกเลิก"
        }
    }else if(status == "REJECT"){
        if(colorText){
            return 'bg-red-status'
        }else{
            return "ไม่อนุมัติ"
        }
    }else if(status == "EXPIRED") {
        if(colorText){
            return 'bg-red-status'
        }else{
            return "หมดอายุ"
        }
    }
}


export const checkRequestTypeSessionHistory = status =>{
    if(status == "RATE"){
        return "เปลี่ยนแปลง % สะสม"
    }else{
        return "ผู้รับผลประโยชน์"
    }
}

export const TextMessagesDetailHistory = (status, providentFundRateHistoryIsActiveBtn) =>{
    if(status == 'PENDING'){
        return 'ดูรายละเอียด'
    }else if(status == 'DRAFT' && providentFundRateHistoryIsActiveBtn === false) {
        return 'ดูรายละเอียด'
    }else if(status == 'DRAFT'){
        return 'แก้ไขข้อมูล'
    }else if(status == 'SUCCESS'){
        return  'ดูรายละเอียด'
    }else if(status == 'CANCEL'){
        return 'ดูรายละเอียด'
    }else if(status == "REJECT"){
        return "ดูรายละเอียด"
    }else if(status == "EXPIRED"){
        return "ดูรายละเอียด"
    }
}